import { render, staticRenderFns } from "./journalAndGl.vue?vue&type=template&id=6368ac52&scoped=true&"
import script from "./journalAndGl.vue?vue&type=script&lang=js&"
export * from "./journalAndGl.vue?vue&type=script&lang=js&"
import style0 from "./journalAndGl.vue?vue&type=style&index=0&id=6368ac52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368ac52",
  null
  
)

export default component.exports